import React from 'react';
import { connect } from 'react-redux';
import { RadioButton } from 'react-custom-radio';
import XIcon from '../../utility/XIcon';
import Loading from '../../utility/Loading';
import {
  getDegreeSubjectDifficultyMapping,
  updateDegreeSubjectDifficultyMapping,
  getHSClassesByAcadplanV2,
  getHSClassesBySubjectDifficultyMapping,
} from '../../../store/actions';

class HighSchoolClassSelectionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      previewLoading: false,
      selections: {},
      lastEdited: null,
      lastEditedBy: '',
      hsClasses: {},
    };
  }

  primaryColor = {
    background: `${this.props.chosenTenant.primary}`,
  };

  primaryBorder = {
    border: `1px solid ${this.props.chosenTenant.primary}`,
  };

  primaryButton = {
    backgroundColor: this.props.chosenTenant.primary,
  };

  secondaryDivider = {
    width: '62px',
    borderTop: `3px solid ${this.props.chosenTenant.secondary}`,
    marginBottom: '32px',
  };

  difficultyButtonSecondaryLine = {
    borderRight: `1px solid ${this.props.chosenTenant.secondary}`,
  };

  loadDegreeSubjectDifficultyMapping = async () => {
    const degreeSubjectDifficultyMapping =
      await this.props.getDegreeSubjectDifficultyMapping(
        this.props.chosenTenant.id,
        this.props.acadPlan
      );

    this.setState({
      selections: {
        Math: degreeSubjectDifficultyMapping.math,
        Science: degreeSubjectDifficultyMapping.science,
        English: degreeSubjectDifficultyMapping.english,
        'Social Studies': degreeSubjectDifficultyMapping.social_studies,
        'Foreign Language': degreeSubjectDifficultyMapping.foreign_language,
        'Fine Art/CTE': degreeSubjectDifficultyMapping.fine_art_cte,
      },
      lastEdited: new Date(
        degreeSubjectDifficultyMapping.last_edited
      ).toLocaleString(),
      lastEditedBy: degreeSubjectDifficultyMapping.last_edited_by.trim(),
    });
  };

  prettifyClasses = (rawHSClasses) => {
    const year1 = Object.values(rawHSClasses).filter((classObj) => {
      return classObj.year === 1;
    });
    const year2 = Object.values(rawHSClasses).filter((classObj) => {
      return classObj.year === 2;
    });
    const year3 = Object.values(rawHSClasses).filter((classObj) => {
      return classObj.year === 3;
    });
    const year4 = Object.values(rawHSClasses).filter((classObj) => {
      return classObj.year === 4;
    });

    const prettyClasses = {
      'Year 1': {
        Math: Object.values(year1).filter((classObj) => {
          return classObj.subject === 'Math';
        }),
        Science: Object.values(year1).filter((classObj) => {
          return classObj.subject === 'Science';
        }),
        English: Object.values(year1).filter((classObj) => {
          return classObj.subject === 'English';
        }),
        'Social Studies': Object.values(year1).filter((classObj) => {
          return classObj.subject === 'Social Studies';
        }),
        'Foreign Language': Object.values(year1).filter((classObj) => {
          return classObj.subject === 'Foreign Language';
        }),
        'Fine Art/CTE': Object.values(year1).filter((classObj) => {
          return classObj.subject === 'Fine Art/CTE';
        }),
      },
      'Year 2': {
        Math: Object.values(year2).filter((classObj) => {
          return classObj.subject === 'Math';
        }),
        Science: Object.values(year2).filter((classObj) => {
          return classObj.subject === 'Science';
        }),
        English: Object.values(year2).filter((classObj) => {
          return classObj.subject === 'English';
        }),
        'Social Studies': Object.values(year2).filter((classObj) => {
          return classObj.subject === 'Social Studies';
        }),
        'Foreign Language': Object.values(year2).filter((classObj) => {
          return classObj.subject === 'Foreign Language';
        }),
        'Fine Art/CTE': Object.values(year2).filter((classObj) => {
          return classObj.subject === 'Fine Art/CTE';
        }),
      },
      'Year 3': {
        Math: Object.values(year3).filter((classObj) => {
          return classObj.subject === 'Math';
        }),
        Science: Object.values(year3).filter((classObj) => {
          return classObj.subject === 'Science';
        }),
        English: Object.values(year3).filter((classObj) => {
          return classObj.subject === 'English';
        }),
        'Social Studies': Object.values(year3).filter((classObj) => {
          return classObj.subject === 'Social Studies';
        }),
        'Foreign Language': Object.values(year3).filter((classObj) => {
          return classObj.subject === 'Foreign Language';
        }),
        'Fine Art/CTE': Object.values(year3).filter((classObj) => {
          return classObj.subject === 'Fine Art/CTE';
        }),
      },
      'Year 4': {
        Math: Object.values(year4).filter((classObj) => {
          return classObj.subject === 'Math';
        }),
        Science: Object.values(year4).filter((classObj) => {
          return classObj.subject === 'Science';
        }),
        English: Object.values(year4).filter((classObj) => {
          return classObj.subject === 'English';
        }),
        'Social Studies': Object.values(year4).filter((classObj) => {
          return classObj.subject === 'Social Studies';
        }),
        'Foreign Language': Object.values(year4).filter((classObj) => {
          return classObj.subject === 'Foreign Language';
        }),
        'Fine Art/CTE': Object.values(year4).filter((classObj) => {
          return classObj.subject === 'Fine Art/CTE';
        }),
      },
    };

    return prettyClasses;
  };

  loadHSClasses = async () => {
    const rawHSClasses = await this.props.getHSClassesByAcadplanV2(
      this.props.chosenTenant.id,
      this.props.acadPlan,
      false
    );

    const prettyClasses = this.prettifyClasses(rawHSClasses);

    this.setState({ hsClasses: prettyClasses });
  };

  loadHSClassesBySubjectDifficultyMapping = async (selections) => {
    const rawHSClasses =
      await this.props.getHSClassesBySubjectDifficultyMapping(
        this.props.chosenTenant.id,
        selections
      );

    const prettyClasses = this.prettifyClasses(rawHSClasses);

    this.setState({ hsClasses: prettyClasses });
  };

  async componentDidMount() {
    this.setState({ loading: true });

    await this.loadDegreeSubjectDifficultyMapping();
    await this.loadHSClasses();

    this.setState({ loading: false });
  }

  saveSelections = async () => {
    this.setState({ loading: true });

    const degreeSubjectDifficultyMapping = {
      math: this.state.selections.Math,
      science: this.state.selections.Science,
      english: this.state.selections.English,
      social_studies: this.state.selections['Social Studies'],
      foreign_language: this.state.selections['Foreign Language'],
      fine_art_cte: this.state.selections['Fine Art/CTE'],
    };

    await this.props.updateDegreeSubjectDifficultyMapping(
      this.props.chosenTenant.id,
      this.props.acadPlan,
      degreeSubjectDifficultyMapping
    );
    await this.loadDegreeSubjectDifficultyMapping();
    await this.loadHSClasses();

    this.setState({ loading: false });
  };

  changeSubjectDifficulty = async (subject, difficulty) => {
    const newSelections = { ...this.state.selections, [subject]: difficulty };

    this.setState((prevState) => ({
      selections: newSelections,
      previewLoading: true,
    }));

    await this.loadHSClassesBySubjectDifficultyMapping(newSelections);

    this.setState({ previewLoading: false });
  };

  radioButton = (subject, difficulty) => {
    const isSelected = this.state.selections[subject] === difficulty;

    return (
      <div className="radio-input">
        <div
          className={isSelected ? 'radio-fill' : 'radio-fill hidden'}
          style={this.primaryColor}
        />
        <RadioButton
          value={difficulty}
          className="radio-button"
          style={this.primaryBorder}
          useHiddenInput
          aria-checked={isSelected}
          aria-label={`${subject} difficulty option: ${difficulty}. ${
            isSelected ? 'selected' : 'unselected'
          }`}
          onClick={() => this.changeSubjectDifficulty(subject, difficulty)}
        />
      </div>
    );
  };

  difficultyButton = (subject, difficulty, rightLine = false) => {
    let boldBit = '';
    let label = difficulty;

    if (difficulty.includes('-')) {
      const difficultyParts = difficulty.split('-');
      label = difficultyParts[0].trim();
      boldBit = difficultyParts[1].trim();
    }

    return (
      <td
        className="high-school-class-selection-modal__class-selection-section__difficulty"
        key={`subjectDifficultyButton-${subject}-${difficulty}`}
      >
        <div
          className="high-school-class-selection-modal__class-selection-section__difficulty-button"
          style={rightLine ? this.difficultyButtonSecondaryLine : {}}
        >
          {this.radioButton(subject, difficulty)}
          {label}
          {!!boldBit && (
            <span className="high-school-class-selection-modal__bold">
              &nbsp;
              {boldBit}
            </span>
          )}
        </div>
      </td>
    );
  };

  subjectDifficultyRow = (subject, difficultyOptions) => {
    return (
      <tr
        className="high-school-class-selection-modal__class-selection-section__row"
        key={`subjectDifficultyRow-${subject}`}
      >
        <td className="high-school-class-selection-modal__class-selection-section__subject">
          {subject}
        </td>
        {difficultyOptions.map((difficulty, i) => {
          return this.difficultyButton(
            subject,
            difficulty,
            i + 1 !== difficultyOptions.length
          );
        })}
      </tr>
    );
  };

  classSelectionSection = () => {
    return (
      <div className="high-school-class-selection-modal__class-selection-section">
        <table className="high-school-class-selection-modal__class-selection-section__table">
          <tbody>
            {this.subjectDifficultyRow('Math', [
              'General',
              'Moderate',
              'Advanced',
            ])}
            {this.subjectDifficultyRow('Science', [
              'General',
              'Advanced - Lab',
              'Advanced - Life',
              'Advanced - Physics',
            ])}
            {this.subjectDifficultyRow('English', ['General', 'Advanced'])}
            {this.subjectDifficultyRow('Social Studies', [
              'General',
              'Advanced',
            ])}
            {this.subjectDifficultyRow('Foreign Language', ['General'])}
            {this.subjectDifficultyRow('Fine Art/CTE', ['General', 'Advanced'])}
          </tbody>
        </table>
        <div className="high-school-class-selection-modal__class-selection-section__bottom-row">
          <div className="high-school-class-selection-modal__class-selection-section__spacer" />
          <div className="high-school-class-selection-modal__class-selection-section__save-button-container">
            <button
              className="high-school-class-selection-modal__class-selection-section__save-button"
              style={this.primaryButton}
              tabIndex={0}
              onKeyDown={async (e) => {
                if (['Enter'].includes(e.key)) await this.saveSelections();
              }}
              onClick={async () => {
                await this.saveSelections();
              }}
              type="submit"
            >
              Save
            </button>
          </div>
          <span className="high-school-class-selection-modal__class-selection-section__last-updated">
            {`Last Updated: ${this.state.lastEditedBy} ${this.state.lastEdited}`}
          </span>
        </div>
      </div>
    );
  };

  previewSection = () => {
    const subjects = [
      'Math',
      'Science',
      'English',
      'Social Studies',
      'Foreign Language',
      'Fine Art/CTE',
      'Electives',
    ];
    const years = [
      ['Year 1', 'Freshman'],
      ['Year 2', 'Sophomore'],
      ['Year 3', 'Junior'],
      ['Year 4', 'Senior'],
    ];

    return (
      <div className="high-school-class-selection-modal__class-preview-section">
        {this.state.previewLoading ? (
          <Loading height="90vh" />
        ) : (
          <>
            <div className="high-school-class-selection-modal__class-preview-section__years">
              <div className="high-school-class-selection-modal__class-preview-section__year-label-spacer" />
              {years.map(([year, yearName]) => (
                <div
                  className="high-school-class-selection-modal__class-preview-section__year-label"
                  key={yearName}
                >
                  <div className="high-school-class-selection-modal__class-preview-section__year">
                    {year}
                  </div>
                  <div className="high-school-class-selection-modal__class-preview-section__year-name">
                    {yearName ? `(${yearName})` : ''}
                  </div>
                </div>
              ))}
            </div>
            <div className="high-school-class-selection-modal__class-preview-section__year-columns">
              <div className="high-school-class-selection-modal__class-preview-section__subjects">
                {subjects.map((subject) => (
                  <div
                    className="high-school-class-selection-modal__class-preview-section__subject-label"
                    key={subject}
                  >
                    {subject}
                  </div>
                ))}
              </div>
              {years.map(([year, yearName]) => (
                <div
                  className="high-school-class-selection-modal__class-preview-section__year-column"
                  key={yearName}
                >
                  <div className="high-school-class-selection-modal__class-preview-section__classes">
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      {this.state.hsClasses[year].Math?.length > 0
                        ? this.state.hsClasses[year].Math[0].titleEn
                        : 'Elective'}
                    </div>
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      {this.state.hsClasses[year].Science?.length > 0
                        ? this.state.hsClasses[year].Science[0].titleEn
                        : 'Elective'}
                    </div>
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      {this.state.hsClasses[year].English?.length > 0
                        ? this.state.hsClasses[year].English[0].titleEn
                        : 'Elective'}
                    </div>
                    {this.state.hsClasses[year]['Social Studies']?.length ===
                    2 ? (
                      <div className="high-school-class-selection-modal__class-preview-section__split-classes">
                        <div className="high-school-class-selection-modal__class-preview-section__split-class">
                          {
                            this.state.hsClasses[year]['Social Studies'][0]
                              .titleEn
                          }
                        </div>
                        <div className="high-school-class-selection-modal__class-preview-section__split-class">
                          {
                            this.state.hsClasses[year]['Social Studies'][1]
                              .titleEn
                          }
                        </div>
                      </div>
                    ) : (
                      <div className="high-school-class-selection-modal__class-preview-section__class">
                        {this.state.hsClasses[year]['Social Studies']?.length >
                        0
                          ? this.state.hsClasses[year]['Social Studies'][0]
                              .titleEn
                          : 'Elective'}
                      </div>
                    )}
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      {this.state.hsClasses[year]['Foreign Language']?.length >
                      0
                        ? this.state.hsClasses[year]['Foreign Language'][0]
                            .titleEn
                        : 'Elective'}
                    </div>
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      {this.state.hsClasses[year]['Fine Art/CTE']?.length > 0
                        ? this.state.hsClasses[year]['Fine Art/CTE'][0].titleEn
                        : 'Elective'}
                    </div>
                    <div className="high-school-class-selection-modal__class-preview-section__class">
                      Elective
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );
  };

  render() {
    return (
      <>
        <div
          className="high-school-class-selection-modal__overlay"
          style={{ position: 'fixed' }}
        />
        <div
          className="high-school-class-selection-modal__modal-container"
          style={{ position: 'fixed' }}
        >
          <div
            className="high-school-class-selection-modal__close-button"
            role="button"
            tabIndex={0}
            onClick={() => {
              this.props.closeModal();
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.props.closeModal();
            }}
          >
            <XIcon color="white" />
          </div>
          <div className="high-school-class-selection-modal__modal-body">
            {this.state.loading ? (
              <Loading height="90vh" />
            ) : (
              <>
                <div className="high-school-class-selection-modal__heading">
                  High School Class Selection
                </div>
                <div className="high-school-class-selection-modal__subheading">
                  <span className="high-school-class-selection-modal__acad-plan">
                    ACAD Plan:&nbsp;
                  </span>
                  <span className="high-school-class-selection-modal__acad-plan-code">
                    {this.props.acadPlan}
                  </span>
                </div>
                {this.classSelectionSection()}
                <div className="high-school-class-selection-modal__heading">
                  Course Recommendation Preview
                </div>
                <div
                  className="high-school-class-selection-modal__divider"
                  style={this.secondaryDivider}
                />
                {this.previewSection()}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  getDegreeSubjectDifficultyMapping,
  updateDegreeSubjectDifficultyMapping,
  getHSClassesByAcadplanV2,
  getHSClassesBySubjectDifficultyMapping,
})(HighSchoolClassSelectionModal);
